/** Session flag: user must finish registration connections step before app redirect. */
const STORAGE_KEY = 'vo2_pending_registration_connections';

export function markPendingRegistrationConnections(): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, '1');
  } catch {
    /* private mode / quota */
  }
}

export function clearPendingRegistrationConnections(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function hasPendingRegistrationConnections(): boolean {
  try {
    return sessionStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

/** Resume only after authentication has restored a real account. */
export function canResumeRegistrationConnections(userId: number | null | undefined): boolean {
  return userId != null && Number.isSafeInteger(userId) && userId > 0 && hasPendingRegistrationConnections();
}
